import React from 'react'
import {Link} from "react-router-dom";
import axios from 'axios';
import '../css/main_style.css';

class TopPart extends React.Component {	  
	constructor(props) {
		super(props);
		this.state = {CompName:''};				
	}

	componentDidMount() {		
		axios.post(process.env.REACT_APP_API_ENV+'api/FindCompanyName.php')
			.then(result => {				
				this.setState({CompName:result.data[0]})													
			})		
	}
	render() {	
		return(
			<div id="headsection">
				<div id="headback">
					<br/><br/><br/>
					<h1>
						<Link to="/Apply" style={{color:"white"}} title="Your Payday loans" target="_blank">{this.state.CompName}</Link> 
						
					</h1>
					<p id="headpara">
						<Link to="/Apply" style={{color:"white"}} title="Faxless Payday Loans">Simple Easy Fast - Your payday loan</Link>
						
					</p>
				</div>
			</div>
		)
	}
}


export default TopPart	